import { render, staticRenderFns } from "./EditUserCustomers.vue?vue&type=template&id=3a778864&scoped=true&"
import script from "./EditUserCustomers.vue?vue&type=script&lang=ts&"
export * from "./EditUserCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./EditUserCustomers.vue?vue&type=style&index=0&id=3a778864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a778864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
